import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { ReservationsProvider } from './context/ReservationsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ReservationsProvider>
        <App />
      </ReservationsProvider>
    </HelmetProvider>
  </React.StrictMode>
);
